export const enEnhancements = {
  enhance: {
    cards: 'Cards',
    large: 'Large cards',
    list: 'List',
    layout: 'Node display',
    expand: 'Expand chart',
    collapse: 'Exit full screen',
    trend: 'Trend',
    approximate: 'Summary uses sampled observations; totals and percentiles are approximate.',
    unknown: 'Unknown time',
    coverage: 'Observation coverage',
    encryptedBackup:
      'Backups are encrypted. Keep the external recovery key separately before restoring.',
    loadSession: 'Cannot check your administrator session. Try again.',
  },
  oidc: {
    title: 'Erauth administrator login',
    description: 'Configure OpenID Connect for administrator access.',
    configure: 'Configure Erauth',
    enabled: 'Enable Erauth login',
    issuer: 'OIDC Issuer URL',
    clientId: 'Client ID',
    clientKey: 'Client Key / Client Secret',
    scopes: 'Scopes',
    authMethod: 'Token authentication',
    subjects: 'Allowed administrator subject IDs',
    emails: 'Allowed verified administrator emails',
    allowlistHint: 'One value per line. At least one allowlist is required before enabling login.',
    callback: 'Callback URL',
    copy: 'Copy callback URL',
    copied: 'Copied',
    keyHint:
      'Leave blank to keep the stored key. You can save this configuration without credentials and enable it later.',
    keyConfigured: 'A key is stored securely',
    clearKey: 'Clear the stored key',
    save: 'Save OIDC configuration',
    saved: 'Configuration saved',
    test: 'Check discovery',
    testing: 'Checking...',
    testOk: 'OIDC discovery passed',
    login: 'Sign in with Erauth',
    disabled: 'Erauth login is awaiting administrator configuration.',
    failed: 'Erauth sign-in failed or this account is not in the administrator allowlist.',
    bootstrap: 'The existing administrator token remains available while you configure Erauth.',
  },
}

export const zhEnhancements = {
  enhance: {
    cards: '卡片',
    large: '大卡片',
    list: '列表',
    layout: '节点显示方式',
    expand: '放大图表',
    collapse: '退出全屏',
    trend: '趋势',
    approximate: '摘要使用采样观测值，流量和分位数为近似值。',
    unknown: '未知时长',
    coverage: '有效观测覆盖率',
    encryptedBackup: '备份已加密。恢复前请单独保管外部恢复密钥。',
    loadSession: '无法检查管理员会话，请重试。',
  },
  oidc: {
    title: 'Erauth 管理员登录',
    description: '通过 OpenID Connect 配置管理员入口。',
    configure: '配置 Erauth',
    enabled: '启用 Erauth 登录',
    issuer: 'OIDC Issuer 地址',
    clientId: 'Client ID',
    clientKey: 'Client Key / Client Secret',
    scopes: '授权范围',
    authMethod: '令牌端点认证方式',
    subjects: '允许登录的管理员 Subject ID',
    emails: '允许登录的管理员已验证邮箱',
    allowlistHint: '每行一个。启用登录前至少填写一种管理员白名单。',
    callback: '回调地址',
    copy: '复制回调地址',
    copied: '已复制',
    keyHint: '留空会保留已保存的密钥。现在可以先保存配置，取得凭据后再启用。',
    keyConfigured: '密钥已安全保存',
    clearKey: '清除已保存的密钥',
    save: '保存 OIDC 配置',
    saved: '配置已保存',
    test: '检查服务发现',
    testing: '检查中…',
    testOk: 'OIDC 服务发现检查通过',
    login: '使用 Erauth 登录',
    disabled: 'Erauth 登录等待管理员配置凭据。',
    failed: 'Erauth 登录失败，或此账户不在管理员白名单中。',
    bootstrap: '配置 Erauth 期间仍可使用现有管理员令牌登录。',
  },
}
